import { combineReducers } from 'redux-immutable'

import ui from './ui'
import data from './data'
import contactsDataGrid from './contacts_data_grid'
import distributionListsDataGrid from './distribution_lists_data_grid'
import imports from './imports'

export default combineReducers({
  ui,
  data,
  contactsDataGrid,
  distributionListsDataGrid,
  imports
})
